import LawyerNotarialBookCard from "./lawyer_notarial_book_card";
import LawyerNotarialBookTable from "./lawyer_notarial_book_table";
const TabLawyers = () => {
    return (
    <>
        <LawyerNotarialBookCard/>
        <LawyerNotarialBookTable/>
    </> );
}
 
export default TabLawyers;